
import React from 'react';

import PropTypes from 'prop-types'

import { Avatar } from '@mui/material';
import { useAuthAccess } from '../../hooks/useAuthAccess'

CommonAvatarIcon.propTypes = {
    name: PropTypes.string,
}

export default function CommonAvatarIcon({ name }) {

    const { authData } = useAuthAccess();

    if (!name) name = authData?.displayName

    const stringToColor = (string) => {

        let hash = 0;
        let i;

        /* eslint-disable no-bitwise */
        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color = '#';

        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }
        /* eslint-enable no-bitwise */

        return color;
    }

    const stringAvatar = (name = "") => {

        if (name === "") {
            name = "-";
        } else {
            name = `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`
        }

        return {
            sx: {
                bgcolor: stringToColor(name),
            },
            children: name,
        };
    }

    return <Avatar {...stringAvatar(name)} />
}

